import {
  hmplusGlobalReleaseConstants,
  addHMPLUSGlobalReleaseConstants,
  editHMPLUSGlobalReleaseConstants,
} from "../_redux-constants";

export function hmplusGlobalReleaseReducer(
  state = {
    hmplusGlobalReleaseLoading: false,
    hmplusGlobalReleaseData: null,
    hmplusGlobalReleaseError: null,

    addHMPLUSGlobalReleaseLoading: false,
    addHMPLUSGlobalReleaseData: null,
    addHMPLUSGlobalReleaseError: null,

    editHMPLUSGlobalReleaseLoading: false,
    editHMPLUSGlobalReleaseData: null,
    editHMPLUSGlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        hmplusGlobalReleaseLoading: true,
        hmplusGlobalReleaseData: null,
        hmplusGlobalReleaseError: null,
        addHMPLUSGlobalReleaseLoading: false,
        addHMPLUSGlobalReleaseData: null,
        addHMPLUSGlobalReleaseError: null,
      });
    case hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        hmplusGlobalReleaseLoading: false,
        hmplusGlobalReleaseData: action.data,
      });
    case hmplusGlobalReleaseConstants.HMPLUS_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        hmplusGlobalReleaseLoading: false,
        hmplusGlobalReleaseData: null,
        hmplusGlobalReleaseError: action.error,
      });

    case addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addHMPLUSGlobalReleaseLoading: true,
        addHMPLUSGlobalReleaseData: null,
        addHMPLUSGlobalReleaseError: null,
      });
    case addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addHMPLUSGlobalReleaseLoading: false,
        addHMPLUSGlobalReleaseData: action.data,
      });
    case addHMPLUSGlobalReleaseConstants.ADD_HMPLUS_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addHMPLUSGlobalReleaseLoading: false,
        addHMPLUSGlobalReleaseData: null,
        addHMPLUSGlobalReleaseError: action.error,
      });

    case editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editHMPLUSGlobalReleaseLoading: true,
        editHMPLUSGlobalReleaseData: null,
        editHMPLUSGlobalReleaseError: null,
      });
    case editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editHMPLUSGlobalReleaseLoading: false,
        editHMPLUSGlobalReleaseData: action.data,
      });
    case editHMPLUSGlobalReleaseConstants.EDIT_HMPLUS_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editHMPLUSGlobalReleaseLoading: false,
        editHMPLUSGlobalReleaseData: null,
        editHMPLUSGlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
